export default __webpack_public_path__ + "static/media/handsonmobile.8e1693ae.jpg";